import { render } from "./RiskManagement.vue?vue&type=template&id=08a5f943"
import script from "./RiskManagement.vue?vue&type=script&lang=js"
export * from "./RiskManagement.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__